import { Grid, Typography, Tooltip, IconButton, Button } from '@mui/material'
import React, { useState } from 'react'
import styles from "../../../assets/styles/componentStyles/apiKeyStyles/apiKeyStyle.module.scss"
import globalStyles from "../../../assets/styles/global.module.scss";
import { useApiKeyStore } from '../../../store/apiKeyStore';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import GlobalButton from '../../../components/utility/globalButton/button';
import GlobalTooltip from '../../../components/utility/tooltip/globalTooltip';

const SaveApiKeyPopup = () => {

    const secretApiKey = useApiKeyStore((store) => store.secretApiKey);
    const setSecretApiKey = useApiKeyStore((store) => store.setSecretApiKey);
    const setFlagSaveApiKeyPopup = useApiKeyStore((store) => store.setFlagSaveApiKeyPopup);

    const [copied, setCopied] = useState<boolean>(false);

    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const onClickOfSecurelyStoredMyKey = () => {
        setFlagSaveApiKeyPopup(false);
        setSecretApiKey(null);
    }

    return (
        <>
            <Grid container gap={2} className={`${globalStyles.flexColumn} ${styles.saveKeyContainerZIndex}`}>
                <Grid item xs={12}>
                    <Grid container gap={2} className={`${styles.saveKeyContainer} ${styles.saveKeyContainerPadding}`}>
                        <Grid item className={`${styles.cardIcon} ${styles.saveKeyWarningIcon}`}>
                            <WarningAmberRoundedIcon />
                        </Grid>
                        <Grid item>
                            <Typography className={`${styles.saveKeyTitle}`}>
                                Save your key!
                            </Typography>
                            <Typography className={`${styles.saveKeyDesc}`}>
                                For security, we show this only once. If you don't save it now, you'll need to create a new one.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} className={styles.saveKeyContainerBodyPadding}>
                    <Grid container gap={2} className={`${globalStyles.flexColumn}`}>
                        <Grid item xs={12}>
                            <Grid container className={`${globalStyles.flexColumn}`} gap={1}>
                                <Grid item>
                                    <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.secondaryFontWeight} ${globalStyles.greyColor}`}>
                                        Your Secret API Key
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Grid container className={styles.copyKeyContainer} gap={1}>
                                        <Grid item>
                                            <Typography className={styles.keyText}>
                                                {secretApiKey}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <CopyToClipboard text={secretApiKey ?? ""} onCopy={handleCopy}>
                                                <Tooltip title={copied ? "Copied!" : "Copy"} placement="top">
                                                    <div className={styles.copyIcon}>
                                                        {copied ? <DoneRoundedIcon /> : <ContentCopyIcon />}
                                                    </div>
                                                </Tooltip>
                                            </CopyToClipboard>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} mt={1}>
                            <Grid container gap={1} className={`${globalStyles.centerAlignment}`}>
                                <GlobalButton
                                    className='primaryButtonStyle'
                                    buttonText="I've securely stored my key"
                                    onClick={() => onClickOfSecurelyStoredMyKey()}
                                    sx={{ width: "250px" }}
                                />
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SaveApiKeyPopup
